import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Wallet from "./pages/Wallet";
import Transactions from "./pages/Transactions";
import Admin from "./pages/Admin";
import Invest from "./pages/Invest";
import Profile from "./pages/Profile";
import Downline from "./pages/Downline";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";

/* ── Global cursor glow ── */
function CursorGlow() {
  const [pos, setPos] = useState({ x: -400, y: -400 });
  useEffect(() => {
    const move = e => setPos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, []);
  return (
    <div style={{
      position: "fixed",
      left: pos.x - 200, top: pos.y - 200,
      width: 400, height: 400,
      background: "radial-gradient(circle, rgba(255,184,0,0.055) 0%, rgba(0,194,255,0.025) 40%, transparent 70%)",
      pointerEvents: "none", zIndex: 99999,
      transition: "left 0.08s linear, top 0.08s linear",
      borderRadius: "50%",
    }} />
  );
}


function DeadEnd() {
  return (
    <div style={{
      minHeight: "100vh",
      display: "grid",
      placeItems: "center",
      background: "#07090E",
      color: "#5a6570",
      fontFamily: "sans-serif",
      fontSize: 14,
    }}>404</div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <CursorGlow />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3500,
          style: {
            background: "rgba(10,18,34,0.97)",
            color: "#e8eefc",
            border: "1px solid rgba(255,184,0,0.25)",
            borderRadius: "12px",
            fontSize: "14px",
            fontFamily: "'Figtree',sans-serif",
            padding: "12px 16px",
            boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
            maxWidth: "90vw",
          },
          success: { iconTheme: { primary: "#00e87a", secondary: "#0a1222" } },
          error:   { iconTheme: { primary: "#ff5c7a", secondary: "#0a1222" } },
        }}
      />
      <Routes>
        <Route path="/"             element={<Home />} />
        <Route path="/login"        element={<Login />} />
        <Route path="/dashboard"    element={<Dashboard />} />
        <Route path="/wallet"       element={<Wallet />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/invest"       element={<Invest />} />
        <Route path="/profile"      element={<Profile />} />
        <Route path="/downline"     element={<Downline />} />
        <Route path="/panel-c1bbf5005c8b42ebeb" element={<Admin />} />
        <Route path="/admin"        element={<DeadEnd />} />
        <Route path="/terms"        element={<Terms />} />
        <Route path="/contact"      element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
